import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  accessToken: '', // APP 传递过来的access_token
  appInfo: {} // APP相关信息，包括oem信息，token，roleType等相关信息
}
const mutations = {
  [types.SET_ACCESS_TOKEN] (state, data) {
    state.accessToken = data
  },
  [types.SET_APP_INFO] (state, data) {
    state.appInfo = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
